import { useCallback, useEffect, useState } from "react"
import styled from "styled-components"
import { ChevronLeft, ChevronRight } from "ui/icons"
import { defaultThemeColors, mediaSizes } from "ui/theme"

export const usePrevNextButtons = (emblaApi) => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true)
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true)

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return
    emblaApi.scrollPrev()
  }, [emblaApi])

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return
    emblaApi.scrollNext()
  }, [emblaApi])

  const onSelect = useCallback((emblaApi) => {
    setPrevBtnDisabled(!emblaApi.canScrollPrev())
    setNextBtnDisabled(!emblaApi.canScrollNext())
  }, [])

  useEffect(() => {
    if (!emblaApi) return

    onSelect(emblaApi)
    emblaApi.on("reInit", onSelect).on("select", onSelect)
  }, [emblaApi, onSelect])

  document.onkeydown = checkKey

  function checkKey(e) {
    e = e || window.event

    if (e.keyCode == "37") {
      embla.scrollPrev()
    } else if (e.keyCode == "39") {
      embla.scrollNext()
    }
  }

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  }
}

export const useEmblaKeyboard = (emblaApi, isActive = true) => {
  useEffect(() => {
    if (!emblaApi || !isActive) return

    const handleKeyDown = (e) => {
      switch (e.key) {
        case "ArrowLeft":
          emblaApi.scrollPrev()
          break
        case "ArrowRight":
          emblaApi.scrollNext()
          break
        default:
          break
      }
    }

    document.addEventListener("keydown", handleKeyDown)

    return () => {
      document.removeEventListener("keydown", handleKeyDown)
    }
  }, [emblaApi, isActive])
}

export const PrevButton = (props) => {
  const { children, chevronColor, ...restProps } = props

  return (
    <EmblaButton {...restProps}>
      <EmblaSvgContainer>
        <ChevronLeft
          style={{
            color: chevronColor,
          }}
        />
      </EmblaSvgContainer>
      {children}
    </EmblaButton>
  )
}

export const NextButton = (props) => {
  const { children, ...restProps } = props

  return (
    <EmblaButton {...restProps}>
      <EmblaSvgContainer>
        <ChevronRight />
      </EmblaSvgContainer>
      {children}
    </EmblaButton>
  )
}

export const EmblaButton = styled.button`
  appearance: none;
  background-color: transparent;
  text-decoration: none;
  cursor: pointer;
  border-radius: 50%;
  width: 44px;
  height: 44px;
  border: 1.5px solid rgba(29, 29, 31, 0.18);
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color 0.2s ease, background 0.2s ease;
  flex-shrink: 0;
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  &:not(:disabled):hover {
    border-color: rgba(29, 29, 31, 0.45);
    background: rgba(29, 29, 31, 0.04);
  }
`

const EmblaSvgContainer = styled.div`
  color: ${defaultThemeColors.txt};
`
